// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requisitionConfirmationProductListStyles } from "@steiner/Overrides/Widgets/RequisitionConfirmation/RequisitionConfirmationProductList";
import { css } from "styled-components";

requisitionConfirmationProductListStyles.cartLinesList = {
    cardExpanded: {
        cartLineContainer: {
            container: {
                css: css`
                    grid-template-columns: 64px minmax(0, 380px) minmax(0, 180px) minmax(0, 124px) minmax(0, 180px) minmax(
                            0,
                            36px
                        );
                `,
            },
        },
    },
    linesHeaderStyles: {
        wrapper: {
            css: css`
                grid-template-columns: 64px minmax(0, 380px) minmax(0, 180px) minmax(0, 124px) minmax(0, 180px) minmax(
                        0,
                        36px
                    );
            `,
        },
    },
};
